// lib
import { EditorState, Modifier } from 'draft-js'

export function removeSelectedContentFromEditorState(editorState) {
  const content = editorState.getCurrentContent()
  const selection = editorState.getSelection()
  return selection.getAnchorKey() == selection.getFocusKey() &&
    selection.getAnchorOffset() == selection.getFocusOffset()
    ? editorState
    : EditorState.push(
        editorState,
        Modifier.removeRange(content, selection, selection.get('isBackward') ? 'backward' : 'forward'),
        'remove-range'
      )
}
